import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: 'rgba(11, 14, 17, 0.6)',
    text1: '#FFFFFF',
    text2: '#D3D3D3',
    text3: '#6C7284',
    text4: '#565A69',

    // backgrounds / greys

    bg0: '#202020',
    bg1: '#303030',
    bg2: '#505050',

    bg3: '#40444F',
    bg4: '#565A69',
    bg5: '#6C7284',

    //specialty colors
    modalBG: 'rgba(0,0,0,.425)',
    advancedBG: 'rgba(0,0,0,0.1)',

    //primary colors

    primary1: '#40444F',
    primary4: '#D3D3D3',

    primary5: '#606060',

    // color text
    primaryText1: '#fff',
    buttonText: '#ffffff',

    // secondary colors
    secondary1: '#505050'
  }
}
